
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.577 30c.598 0 1.082-.56 1.082-1.25s-.484-1.25-1.082-1.25h-4.33c-.597 0-1.081-.56-1.081-1.25v-12.5c0-.69.484-1.25 1.082-1.25h4.33c.597 0 1.081-.56 1.081-1.25S31.175 10 30.577 10h-4.33c-1.792 0-3.246 1.679-3.246 3.75v12.5c0 2.071 1.454 3.75 3.247 3.75h4.33zm.99-7.557a.667.667 0 000 .957l.666.647a.667.667 0 00.93 0l3.635-3.535a.667.667 0 000-.957l-3.635-3.535a.667.667 0 00-.93 0l-.665.647a.667.667 0 000 .956l1.398 1.36h-4.86v2.106h4.854l-1.392 1.354z","fill":"#fff"}})])
          )
        }
      }
    